import { CommonModule } from "@angular/common";
import { Component, EventEmitter, Input, Output } from "@angular/core";
import { SharedDsnModule } from "@app/shared/modules/shared-dsn.module";
import { SharedMaterialModule } from "@app/shared/modules/shared-material.module";
import { NumberFormatTooltipDirective } from "@app/shared/directives/number-format-tooltip.directive";

@Component({
    selector: "app-balance-account-card",
    imports: [
        SharedMaterialModule,
        SharedDsnModule,
        CommonModule,
        NumberFormatTooltipDirective
    ],
    templateUrl: "./balance-account-card.component.html",
    styleUrl: "./balance-account-card.component.scss"
})
export class BalanceAccountCardComponent {
    @Input({ required: false }) type: "default" | "main" | "submain" =
        "default";
    @Input({ required: true }) serie: {
        _id: string;
        name: string;
        unit: string;
    };
    @Input({ required: true }) base: PeriodValues;
    @Input({ required: true }) comparation?: PeriodValues;
    @Input({ required: true }) ah?: AnalysisHorizontalValues;
    @Input({ required: false }) isExpanded: boolean = true;
    @Input({ required: false }) hideExpandButton: boolean = false;
    @Input({ required: false }) pdf: boolean = false;

    @Output() handleExpand = new EventEmitter<void>();

    get progressClasses(): string {
        if (this.base?.av?.value >= 100) {
            return "full-width";
        }
        return "";
    }

    get progressStyle(): { [key: string]: string } {
        return {
            "--progress-width": `${this.base?.av?.value || 0}%`
        };
    }
}

type PeriodValues = {
    valueFormatted: string;
    value: number;
    dateFormatted: string;
    date: Date;
    av?: {
        value: number;
        valueFormatted: string;
        explanation?: string;
    };
};

type AnalysisHorizontalValues = {
    valueFormatted: string;
    value: number;
    explanation: string;
    direction: "up" | "down" | "stable";
    polarityColor: "good" | "bad" | "stable";
};

export interface BalanceAccountCard {
    serie: { _id: string; name: string; unit: string };
    type: "default" | "main" | "submain";
    base: PeriodValues;
    comparation?: PeriodValues;
    ah?: AnalysisHorizontalValues;
    isExpanded: boolean;
    compound: string[];
}
